import Sha256 from '@/utils/Sha256'

export default {
  /**
   * 获取文件名和行号
   * @param {Number} level
   */
  getFileLine(level) {
    const rawFileLine = new Error().stack?.split('\n')[level + 2]
    if (!rawFileLine) {
      return
    }
    const begin = rawFileLine.indexOf('(')
    const end = rawFileLine.indexOf(')')
    return rawFileLine.substring(begin + 1, end)
  },
  /**
   * 根据源码位置生成UUID
   */
  getFileLineUuid() {
    const stack = new Error().stack
    if (stack === null || stack === undefined || stack.length === 0) {
      return
    }
    return new Sha256(stack).toHex()
  }
}
